(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/download-order.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/download-order.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const Button = svs.ui.ReactButton;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.constants.TEXTS.DOWNLOAD_ORDER,
  DOWNLOAD_BUTTON_LABEL = _svs$ticket_partner$m.DOWNLOAD_BUTTON_LABEL,
  SEND_AGAIN_LABEL = _svs$ticket_partner$m.SEND_AGAIN_LABEL,
  SEND_AGAIN_SUCCESS_MESSAGE = _svs$ticket_partner$m.SEND_AGAIN_SUCCESS_MESSAGE,
  SEND_AGAIN_SUCCESS_TITLE = _svs$ticket_partner$m.SEND_AGAIN_SUCCESS_TITLE,
  SEND_AGAIN_MISSING_PHONE = _svs$ticket_partner$m.SEND_AGAIN_MISSING_PHONE;
const useDownloadTextHook = (numberOfDownloads, lastDownload) => {
  const getDateAndTime = useCallback(lastDownload => "".concat(svs.utils.date.SimpleDate(new Date(lastDownload)), " ").concat(svs.utils.date.SimpleTime(new Date(lastDownload))), []);
  const _useState = useState(numberOfDownloads),
    _useState2 = _slicedToArray(_useState, 2),
    tempNumberOfDownloads = _useState2[0],
    setTempNumberOfDownloads = _useState2[1];
  const _useState3 = useState(getDateAndTime(lastDownload)),
    _useState4 = _slicedToArray(_useState3, 2),
    tempDownloadedDate = _useState4[0],
    setTempDownloadedDate = _useState4[1];
  const generateDownloadText = useCallback((numberOfDownloads, lastDownload) => "".concat(numberOfDownloads, " ").concat(numberOfDownloads > 1 ? 'gånger' : 'gång', " (senast ").concat(getDateAndTime(lastDownload), ")"), [getDateAndTime]);
  const _useState5 = useState(generateDownloadText(tempNumberOfDownloads, tempDownloadedDate)),
    _useState6 = _slicedToArray(_useState5, 2),
    downloadText = _useState6[0],
    setDownloadText = _useState6[1];
  useEffect(() => {
    setDownloadText(generateDownloadText(tempNumberOfDownloads, tempDownloadedDate));
  }, [tempNumberOfDownloads, tempDownloadedDate, generateDownloadText]);
  const setDownloadData = useCallback((numberOfDownloads, downloadDate) => {
    setTempNumberOfDownloads(numberOfDownloads);
    setTempDownloadedDate(getDateAndTime(downloadDate));
  }, [getDateAndTime]);
  return {
    downloadText,
    setDownloadData,
    tempNumberOfDownloads
  };
};
const DownloadOrder = _ref => {
  let numberOfDownloads = _ref.numberOfDownloads,
    lastDownload = _ref.lastDownload,
    orderId = _ref.orderId;
  const _useDownloadTextHook = useDownloadTextHook(numberOfDownloads, lastDownload),
    downloadText = _useDownloadTextHook.downloadText,
    tempNumberOfDownloads = _useDownloadTextHook.tempNumberOfDownloads,
    setDownloadData = _useDownloadTextHook.setDownloadData;
  const onDownload = async (e, orderId) => {
    e === null || e === void 0 || e.preventDefault();
    svs.ui.loader.show();
    try {
      const _await$svs$ticket_par = await svs.ticket_partner.services.downloadOrder(orderId),
        response = _await$svs$ticket_par.response;
      svs.ticket_partner.services.downloadZip(response, orderId);
      setDownloadData(tempNumberOfDownloads + 1, Date.now());
    } catch (e) {
      svs.ticket_partner.logger.error('Failed to get zip');
      svs.ticket_partner.utils.showErrorDialog();
    }
    svs.ui.loader.hide();
  };
  const onSendAgain = async (e, orderId) => {
    e === null || e === void 0 || e.preventDefault();
    svs.ui.loader.show();
    try {
      var _data$response$msg;
      const data = await svs.ticket_partner.services.sendPassword(orderId);
      if (((_data$response$msg = data.response.msg) === null || _data$response$msg === void 0 ? void 0 : _data$response$msg.toLowerCase().indexOf('phone missing')) >= 0) {
        svs.ticket_partner.utils.showErrorDialog(SEND_AGAIN_MISSING_PHONE);
      } else {
        svs.ticket_partner.utils.showSuccessDialog(SEND_AGAIN_SUCCESS_MESSAGE, SEND_AGAIN_SUCCESS_TITLE);
      }
    } catch (e) {
      svs.ticket_partner.logger.error('Failed to send password', e);
      svs.ticket_partner.utils.showErrorDialog();
    }
    svs.ui.loader.hide();
  };
  return React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement("div", null, React.createElement("p", null, "Har du inte f\xE5tt dina best\xE4llda digitala lotter eller tappat bort koderna? Du kan h\xE4mta en lista \xF6ver koderna igen."), React.createElement("b", null, "H\xE4mtad: \xA0"), React.createElement("span", null, downloadText)), React.createElement("div", null, React.createElement("b", null, "Dekrypteringsnyckel: \xA0"), React.createElement("span", null, "Har skickats via SMS. "), React.createElement("a", {
    href: "",
    onClick: e => onSendAgain(e, orderId)
  }, SEND_AGAIN_LABEL), React.createElement("div", {
    className: "margin-top-1 margin-bottom-1"
  }, React.createElement(Button, {
    inverted: true,
    onClick: e => onDownload(e, orderId)
  }, DOWNLOAD_BUTTON_LABEL))));
};
svs.ticket_partner.myOrders.components.DownloadOrder = DownloadOrder;

 })(window);